class NSSFooter extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.els = {
      menus: this.querySelectorAll(`.nss-footer__menu`),
      page1: this.querySelector(`[nss-newsletter-page="1"]`),
      page2: this.querySelector(`[nss-newsletter-page="2"]`),
    }
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Footer] Connected.`);

    this.addEventListener(`click`, this.handleClick.bind(this));
  }

  handleClick(e) {
    if (this.debug) console.log(`[NSS][Footer] Clicked, e.target:`, e.target);

    const parentEl = e.target.parentElement;

    if (e.target.hasAttribute(`nss-newsletter-next`)) {
      this.els.page1.classList.remove(`nss-active`);
      this.els.page2.classList.add(`nss-active`);
    }

    if (
      parentEl.classList.contains(`nss-footer__menu`) &&
      parentEl.classList.contains(`nss-active`)
    ) {
      parentEl.classList.remove(`nss-active`);
    } else if (
      parentEl.classList.contains(`nss-footer__menu`) &&
      !parentEl.classList.contains(`nss-active`)
    ) {
      this.closeAllMenus();
      parentEl.classList.add(`nss-active`);
    }
  }

  closeAllMenus() {
    this.els.menus.forEach((menu) => menu.classList.remove(`nss-active`));
  }

}

let elementName = `nss-footer`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSFooter);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}